import { getTranslationNamespace } from '../../helpers/getTranslationNamespace'

const TRANSLATION_NAMESPACE = getTranslationNamespace('-not-applicable')

export const TRANSLATION_KEYS = {
  categoryIsNotApplicable: `${TRANSLATION_NAMESPACE}--category-is-not-applicable`,
  switchOn: `${TRANSLATION_NAMESPACE}--switch-on`,
}
